import React, { useState } from 'react';
import { IconButton, Tooltip, Typography } from '@mui/material';
import { ContentCopy as ContentCopyIcon } from '@mui/icons-material';

const CopyValueButton = ({ value, label = 'value', size = 'small', color = 'primary', onCopyError }) => {
  const [copied, setCopied] = useState(false);

  const copyValue = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {
      if (onCopyError) onCopyError();
    }
  };

  return (
    <>
      <Tooltip title={copied ? 'Copied' : `Copy ${label}`}>
        <IconButton
          size={size}
          aria-label={`Copy ${label}`}
          onClick={copyValue}
          sx={{ color: copied ? 'success.main' : `${color}.main` }}
        >
          <ContentCopyIcon sx={{ fontSize: size === 'small' ? 16 : 18 }} />
        </IconButton>
      </Tooltip>
      {copied && (
        <Typography variant="caption" color="success.main" sx={{ whiteSpace: 'nowrap' }}>
          Copied
        </Typography>
      )}
    </>
  );
};

export default CopyValueButton;
